<template>
  <v-container fluid class="pa-5">
    <v-layout row wrap justify-space-between align-center mb-3>
      <v-flex md9>
        <h4 class="headline">Flujos de cobranza</h4>
      </v-flex>
      <v-flex md3 text-xs-right>
        <v-btn v-if="canCreate" class="k-orange-linear mr-0" @click="createWorkflow">Crear flujo</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-3>
      <v-flex md9 pr-3>
        <v-text-field v-model="search" color="black" placeholder="Buscar..." solo />
      </v-flex>
      <v-flex md3>
        <v-select
          v-model="filters.status"
          :items="statusList"
          color="black"
          placeholder="Buscar..."
          solo
        />
      </v-flex>
    </v-layout>
    <br />
    <v-layout row wrap>
      <v-flex xs12>
        <data-table
          ref="workflowTable"
          url="workflows"
          :search="search"
          :filters="filters"
          @items-reload="workflows = $event"
        >
          <template slot="content" v-for="(workflow, i) in workflows">
            <v-list-tile
              :key="`workflow-${workflow.id}`"
              @click="$router.push(`/flows_v3/${workflow.id}`)"
              avatar
            >
              <v-list-tile-avatar>
                <v-icon class="k-orange-linear-text" large>fas fa-code-branch</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <strong>{{ workflow.name }}</strong>
                </v-list-tile-title>
                <v-list-tile-sub-title v-if="workflow.description">{{ workflow.description }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-spacer></v-spacer>
              <v-chip
                small
                :class="{'green': workflow.status === 'Activo', 'red': workflow.status === 'Inactivo'}"
                class="white--text"
              >
                <v-icon class="pr-2 x-small-icon" v-if="workflow.status === 'Activo'">fas fa-check</v-icon>
                <v-icon class="pr-2 x-small-icon" v-if="workflow.status === 'Inactivo'">fas fa-times</v-icon>
                {{ workflow.status }}
              </v-chip>
              <v-list-tile-action v-if="canEdit || canDelete">
                <v-menu bottom offset-y @click.native.stop>
                  <v-btn slot="activator" color="grey darken-2" small flat fab>
                    <v-icon>fas fa-ellipsis-v</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-if="canEdit" @click="duplicate(workflow)">
                      <v-list-tile-title>Duplicar</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="canEdit" @click="changeStatus(workflow)">
                      <v-list-tile-title>{{ workflow.status === 'Activo' ? 'Desactivar' : 'Activar' }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="canDelete" @click="deleteWorkflow(workflow)">
                      <v-list-tile-title>Eliminar</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="i !== workflows.length - 1" :key="`divider${i}`" />
          </template>
        </data-table>
      </v-flex>
    </v-layout>
    <workflow-dialog
      :show="workflowDialog"
      :workflow="workflow"
      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
      @created="$router.push(`/flows_v3/${$event.id}`)"
      @updated="workflowUpdated"
      @close="workflowDialog = false"
    />
    <change-status
      :show="changeStatusDialog"
      :workflow="workflow"
      @updated="workflowUpdated"
      @close="changeStatusDialog = false"
    />
    <delete-workflow
      :show="deleteDialog"
      :workflow="workflow"
      @deleted="workflowDeleted"
      @close="deleteDialog = false"
    />
  </v-container>
</template>

<script>
import Vue from 'vue';
import DataTable from '@/components/global/DataTable2';
import ChangeStatus from '@/components/CollectWorkflows/ChangeStatus';
import DeleteWorkflow from '@/components/CollectWorkflows/DeleteWorkflow';
import WorkflowDialog from '@/components/CollectWorkflows/WorkflowDialog';
import permissionsMixin from '@/mixins/permissions';

export default {
  components: {
    DataTable,
    WorkflowDialog,
    ChangeStatus,
    DeleteWorkflow,
  },
  mixins: [ permissionsMixin ],
  // beforeRouteEnter(to, from, next) {
  //   Vue.axios.get('check_release', { params: { name: 'whatsapp_outbound_project' } })
  //     .then(({ data }) => {
  //       next((vm) => {
  //         vm.isWhatsappOutboundActive = data.is_active;
  //       });
  //     });
  // },
  data() {
    return {
      workflowDialog: false,
      changeStatusDialog: false,
      deleteDialog: false,
      isWhatsappOutboundActive: true,
      search: '',
      filters: {
        status: '',
      },
      statusList: [
        {
          text: 'Todos',
          value: '',
        },
        {
          text: 'Activo',
          value: 'Activo',
        },
        {
          text: 'Inactivo',
          value: 'Inactivo',
        },
      ],
      workflow: {},
      workflows: [],
    };
  },
  computed: {
    canCreate() {
      return this.checkPermissions([
        'create_workflow_notifications',
      ]);
    },
    canEdit() {
      return this.checkPermissions([
        'create_workflow_notifications',
        'edit_workflow_notifications',
      ]);
    },
    canDelete() {
      return this.checkPermissions([
        'delete_workflow_notifications',
      ]);
    },
  },
  methods: {
    createWorkflow() {
      this.workflow = {};
      this.workflowDialog = true;
    },
    changeStatus(workflow) {
      this.workflow = workflow;
      this.changeStatusDialog = true;
    },
    editWorkflow(workflow) {
      this.workflow = workflow;
      this.workflowDialog = true;
    },
    deleteWorkflow(workflow) {
      this.workflow = workflow;
      this.deleteDialog = true;
    },
    workflowUpdated(workflow) {
      const index = this.workflows.findIndex(item => item.id === workflow.id);
      this.$set(this.workflows, index, workflow);
      this.workflowDialog = false;
    },
    workflowDeleted() {
      this.$refs.workflowTable.$emit('update');
      this.deleteDialog = false;
    },
    async duplicate(workflow) {
      const result = await this.axios.post(`workflows/${workflow.id}/copy`).then(() => true).catch(() => false);

      if (!result) {
        return EventBus.$emit('error', 'Ocurrio un error intente nuevamente');
      }

      return this.$refs.workflowTable.$emit('update');
    },
  },
};
</script>
<style>
.overMax{
  color: red
}
</style>


// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/IndexV2.vue